import ErrorMessage from "../../atoms/forms/ErrorMessage";
import Label from "../../atoms/forms/Label";
import SocialLink from "../../atoms/forms/SocialLink";

type Props = {
  id: string;
  label: React.ReactNode;
  errorMessage: any;
  register: any;
  additionalClasses?: string;
  fieldAddOn?: string;
  placeHolder?: string;
  getValues: any;
  setValue: any;
  labelClasses?: string | undefined;
  fieldAddOnClasses?: string | undefined;
};

function SocialLinkElement({
  fieldAddOn,
  getValues,
  id,
  additionalClasses,
  placeHolder,
  label,
  errorMessage,
  register,
  setValue,
  labelClasses = "",
  fieldAddOnClasses = "",
}: Props) {
  return (
    <div>
      <Label labelClasses={labelClasses} htmlFor={id} label={label} />
      <SocialLink
        fieldAddOnClasses={fieldAddOnClasses}
        id={id}
        fieldAddOn={fieldAddOn}
        additionalClasses={additionalClasses}
        placeHolder={placeHolder}
        register={register}
        getValues={getValues}
        setValue={setValue}
      />
      <ErrorMessage errorMessage={errorMessage} />
    </div>
  );
}

export default SocialLinkElement;

SocialLinkElement.defaultProps = {
  fieldAddOn: "https://",
  placeHolder: "Enter Website Link",
  additionalClasses: "",
};
